module.exports = __webpack_public_path__ + "ca0c8d76771ee66f274ea8aa4f4c8b10.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/PFDinTextPro-Thin.ttf
// module id = 50
// module chunks = 0